import ObjectList from './container/index';

export default ObjectList;


// WEBPACK FOOTER //
// ./src/views/ObjectList/index.js